import { useState, useEffect, Fragment, useRef } from 'react';

import { Dialog, Transition } from '@headlessui/react'
import { AdminGetUser } from '../../../../Common/lib/Admin/AdminAPI';

export default function RequestModal({ openRequestModal, setOpenRequestModal, requestInfo, approveUser, declineUser }) {
  const [user, setUser] = useState([]);

  const acceptButtonRef = useRef();

  /**
   * Retrives more information about the user who submitted this request.
   */
  const getUser = async () => {
    try {
      const result = await AdminGetUser(requestInfo.userID);

      let userObject = {};

      result.UserAttributes.map(x => {
        userObject[`${x.Name}`] = x.Value;
      });
      
      setUser(userObject);
    } catch (e) {
      // console.log(e);
    }
  };

  useEffect(() => {
    if (openRequestModal) {
      getUser();
    }
  }, [openRequestModal]);

  

  return (
    <Transition.Root show={openRequestModal} as={Fragment}>
      <Dialog as="div" className="relative z-10" initialFocus={acceptButtonRef} onClose={setOpenRequestModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="mt-24 relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div>
                  <div className="mt-3 text-center sm:mt-5">
                    <Dialog.Title as="h3" className="text-lg font-semibold leading-6 text-gray-900">
                      Review Request
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        Please make sure your information is correct before requesting verification
                      </p>
                    </div>
                  </div>
                </div>
                {/* <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3"></div> */}
                <div className="mt-5 sm:mt-6">

                  <div className="mt-12 w-full grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2">
                    <p>
                      <span className="block font-medium text-gray-900">First Name</span>
                      <span className="block text-gray-900 text-sm">
                        {user.given_name}
                      </span>
                    </p>
                    <p>
                      <span className="block font-medium text-gray-900">Last Name</span>
                      <span className="block text-gray-900 text-sm">
                        {user.family_name}
                      </span>
                    </p>
                    <p>
                      <span className="block font-medium text-gray-900">Email</span>
                      <span className="block text-gray-900 text-sm">
                        {user.email}
                      </span>
                    </p>
                    <p>
                      <span className="block font-medium text-gray-900">Phone Number</span>
                      <span className="block text-gray-900 text-sm">
                        {user.phone_number}
                      </span>
                    </p>
                    <p>
                      <span className="block font-medium text-gray-900">University/Research Institute</span>
                      <span className="block text-gray-900 text-sm">
                        {user.institute}
                      </span>
                    </p>
                    <p>
                      <span className="block font-medium text-gray-900">Field of Research</span>
                      <span className="block text-gray-900 text-sm">
                        {user.research_field}
                      </span>
                    </p>
                    <p>
                      <span className="block font-medium text-gray-900">Location of Research</span>
                      <span className="block text-gray-900 text-sm">
                        {user.research_geo}
                      </span>
                    </p>
                  </div>

                  <div className="mt-8 sm:col-span-6">
                    <label
                      htmlFor="info"
                      className="block text-base font-semibold text-gray-900"
                    >
                      Additional Info
                    </label>
                    <span className="block text-gray-900 text-sm">
                      {requestInfo.userInfo !== undefined ? JSON.parse(requestInfo.userInfo).info : null}
                    </span>
                  </div>

                  <div className="mt-12 grid sm:space-x-3 space-x-0 sm:grid-cols-2">
                    <button
                      type="button"
                      ref={acceptButtonRef}
                      className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 sm:col-start-1"
                      onClick={() => approveUser(requestInfo)}
                    >
                      Accept
                    </button>
                    <button
                      type="button"
                      className="mt-2 inline-flex w-full justify-center rounded-md text-gray-700 bg-gray-300 px-3 py-2 text-sm font-semibold shadow-sm focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 hover:bg-gray-400 sm:col-start-2 sm:mt-0"
                      onClick={() => declineUser(requestInfo)}
                    >
                      Decline
                    </button>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}